import { selectAuth, useAppSelector } from "@redux";
import { CircularLoader } from "../Common";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

export const BusinessCardsView = () => {
  const user = useAppSelector(selectAuth);
  const userId = user.userInfo?.id;
  const [loading, setLoading] = useState(true);
  const [iframeKey, setIframeKey] = useState(0); // key to force iframe remount
  const location = useLocation();
  const lastPathRef = useRef(location.pathname);

  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const domain = host.split(".").slice(-2).join("."); // e.g., "live-let.com", "more-do.jp"
  const iframeSrc = `https://cards.${domain}?userKey=${userId}&refresh=${new Date().getTime()}`;

  useEffect(() => {
    if (location.pathname === lastPathRef.current) {
      // same route clicked again
      setIframeKey(prev => prev + 1); // triggers iframe remount
    }
    lastPathRef.current = location.pathname;
  }, [location]);

  return (
    <div style={{ position: "absolute", left: 0, right: 0, top: "6.5rem", bottom: 0, backgroundColor: "#fff" }}>
      <CircularLoader loading={loading} />
      <iframe
        key={iframeKey} // key change causes iframe remount = reload
        src={iframeSrc}
        title="Business Cards"
        style={{ width: '100%', height: '100%', border: 'none' }}
        allow="camera"
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
      />
    </div>
  );
};